import { Tracker, TrackerUserProperties, TrackingEvent } from './tracker';
import { User } from '../../auth/interfaces/user';
import { ExecIfDefined } from '../../shared/utils/decorators';

declare const mixpanel: {
  has_opted_out_tracking: () => boolean;
  opt_in_tracking: VoidFunction;
  opt_out_tracking: () => boolean;
  reset: VoidFunction;
  identify: (identity: string) => void;
  setUserVars: (params: TrackerUserProperties) => void;
  track: (action: TrackingEvent['action'], properties: TrackingEvent['properties']) => void;
  people: {
    set: (data: TrackerUserProperties) => void;
  };
};

export class MixpanelService implements Tracker {
  @ExecIfDefined('mixpanel')
  start() {
    if (mixpanel.has_opted_out_tracking()) {
      mixpanel.opt_in_tracking();
    }
  }

  @ExecIfDefined('mixpanel')
  stop() {
    mixpanel.opt_out_tracking();
  }

  @ExecIfDefined('mixpanel')
  reset() {
    mixpanel.reset();
  }

  @ExecIfDefined('mixpanel')
  setIdentity(user: User) {
    mixpanel.people.set({
      'User ID': user.id,
      Company: user.teamName,
      'Company ID': user.teamId,
      Env: user.clusterId,
      $email: user.email,
      $name: user.name,
      $created: user.createdTs
    });

    mixpanel.identify(user.email);
  }

  @ExecIfDefined('mixpanel')
  updateUserProperties(user: User, data: TrackerUserProperties) {
    mixpanel.people.set(data);
    mixpanel.identify(user.email);
  }

  @ExecIfDefined('mixpanel')
  track(event: TrackingEvent) {
    mixpanel.track(event.action, event.properties);
  }

  @ExecIfDefined('mixpanel')
  pageTrack(path: string) {
    this.track({
      action: 'Page Viewed',
      properties: {
        page: path
      }
    });
  }
}

export const mixpanelService = new MixpanelService();
